import { FC } from "react";
import { useTranslation } from "react-i18next";

import { LandingLayout, LoaderMuiLanding } from "@ryde/controls-landing";
import {
  CompanyScopeLandingsContextWrapper,
  ILandingPage,
  LandingCompanyIdEnum,
  useLandingInit,
} from "@ryde/utils-landings";

import { WixWrapper } from "./wix-wrapper.styled";

export const WixPage: FC<ILandingPage> = ({ companyId }) => {
  const { t } = useTranslation();
  const { landingInitData, isLoading } = useLandingInit({ companyId });
  return (
    <>
      {landingInitData && (
        <CompanyScopeLandingsContextWrapper
          companyId={landingInitData.companyId}
        >
          <WixWrapper>
            <LandingLayout stepsContainerId={LandingCompanyIdEnum.Wix} />
          </WixWrapper>
        </CompanyScopeLandingsContextWrapper>
      )}
      {isLoading && <LoaderMuiLanding loading text={t("ui.LOADING_DATA")} />}
    </>
  );
};
